import { useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from "react";

import { AuthButton, Authorization, CurrentMonth, Datas, TokenContext } from "../App";
import s from '../styles/Buy.module.css';

interface ApplyPromoResponse {
  success: boolean;
  discount: number;
}

interface ExtendSubInvoiceResponse {
  url?: string;
  id?: string;
  num_id?: string;
  amount?: number;
  free?: boolean;
}

const API_BASE = 'https://libervpn.ru/api';
// const API_BASE = 'http://localhost:5000';

const monthMap: Record<number, number> = { 1: 30, 3: 90, 6: 180, 12: 360 };

const Buy = () => {
  const navigate = useNavigate();
  const tokenContext = useContext(TokenContext);
  const datasContext = useContext(Datas);
  const authContext = useContext(Authorization);
  const currentMonthContext = useContext(CurrentMonth);
  const authButtonContext = useContext(AuthButton);

  const [month, setMonth] = useState<number>(0);
  const [price, setPrice] = useState<number>(0);
 
  const [promoCode, setPromoCode] = useState<string>('');
  const [promoApplied, setPromoApplied] = useState<boolean>(false);
  const [promoError, setPromoError] = useState<string>('');
  const [discount, setDiscount] = useState<number>(0);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [paymentInfo, setPaymentInfo] = useState<{ url: string; orderId: string } | null>(null);
  const [paymentError, setPaymentError] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const ref = params.get('month');

  const displayMonths = Math.round((currentMonthContext?.currentMonth || 0) / 30);

  const CalendarIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

  useEffect(() => {
    const refMonths = Number(ref);
    const refDays = monthMap[refMonths] ?? 0;
    if (refDays) {
      currentMonthContext?.setCurrentMonth(refDays);
      setMonth(refDays);
    }
  }, []);

  useEffect(() => {
    if (currentMonthContext?.currentMonth !== undefined && currentMonthContext.currentMonth !== 0) {
      setMonth(currentMonthContext.currentMonth);
    }
  }, [currentMonthContext?.currentMonth]);

  useEffect(() => {
    const prices: Record<number, number> = { 30: 149, 90: 390, 180: 810, 360: 1200 };
    setPrice(prices[month] ?? 0);
  }, [month]);

  async function applyPromo() {
    setPromoError('');

    if (!authContext?.auth) {
      setPromoError('Войдите в аккаунт для применения промокода');
      return;
    }
    
    try {
      const response = await fetch(`${API_BASE}/apply_promo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': `${tokenContext?.token || ''}`
        },
        body: JSON.stringify({ code: promoCode.toLocaleLowerCase(), month: month })
      });

      const res: ApplyPromoResponse = await response.json();

      if (res.success) {
        setDiscount(res.discount);
        setPromoApplied(true);
      } else {
        setPromoError('Промокод недействителен');
      }
    } catch (err) {
      setPromoError('Ошибка при проверке промокода');
    }
  }

  async function extendSub() {
    if (!authContext?.auth) {
      authButtonContext?.setAuthBut(true);
      // navigate('/');
      return;
    }

    setIsLoading(true);

    try {
      const invoiceResRaw = await fetch(`${API_BASE}/extend_sub`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': `${tokenContext?.token || ''}`
        },
        body: JSON.stringify({ amount: month, discount: discount, promoCode: promoCode })
      });
      console.log(month);
      const invoiceRes: ExtendSubInvoiceResponse = await invoiceResRaw.json();
      console.log(invoiceRes);
      if (invoiceResRaw.status === 200 && invoiceRes.free) {
        navigate('/profile');
      }
      if (invoiceResRaw.status === 200 && invoiceRes.url) {
        window.open(invoiceRes.url, '_blank');
        
        setPaymentInfo({
          url: invoiceRes.url,
          orderId: invoiceRes.num_id || invoiceRes.id || 'Неизвестен'
        });
      }
      if (!invoiceResRaw.ok) {
        setPaymentError(true);
      }
      
    } catch (err) {
      console.error(err);
      setPaymentError(true);
    } finally {
      setIsLoading(false); 
    }
  }

  function deleteItem() {
    currentMonthContext?.setCurrentMonth(0);
  }

  function ClosePaymentError() {
    setPaymentError(false);
  }

  const finalPrice = Math.max(0, price - Math.round((price * discount) / 100));

  return (
    <>
     <div className={s.hero_glow}></div>
      {paymentInfo && (
        <div className={s.modal_overlay} onClick={() => setPaymentInfo(null)}>
          <div className={s.modal_content} onClick={(e) => e.stopPropagation()}>
            <h2>Заказ успешно создан!</h2>
            <p>Ваш номер заказа: <strong>{paymentInfo.orderId}</strong></p>
            <p>Если вас не перекинуло на страницу оплаты автоматически (например, браузер заблокировал всплывающее окно), нажмите на кнопку ниже:</p>
            <a 
              href={paymentInfo.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              className={s.pay_link_btn}
            >
              Перейти к оплате
            </a>
            <button 
              className={s.close_modal_btn} 
              onClick={() => {
                setPaymentInfo(null);
                navigate('/profile');
              }}
            >
              Закрыть и перейти в профиль
            </button>
          </div>
        </div>
      )}

      {currentMonthContext?.currentMonth !== 0 ? (
        <div className={s.page}>
          <h1 className={s.title}>Корзина</h1>
          <p className={s.subtitle}>Проверь свою подписку и перейди к оформлению</p>

          <div className={s.card}>
            <p className={s.section_title}>Товар в корзине</p>
            <div className={s.item}>
              {/* <div className={s.item_icon}>📅</div> */}
              <div className={s.item_icon}><CalendarIcon /></div>
              <div className={s.item_info}>
                <p className={s.item_month}>
                  {displayMonths}{" "}
                  {displayMonths === 1
                    ? "Месяц"
                    : displayMonths >= 2 && displayMonths <= 4
                    ? "Месяца"
                    : "Месяцев"}
                </p>
              </div>
              <div className={s.item_right}>
                <p className={s.item_total}>{price} ₽</p>
                <button className={s.delete_btn} onClick={deleteItem}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <polyline points="3 6 5 6 21 6" />
                    <path d="M19 6l-1 14H6L5 6" />
                    <path d="M10 11v6M14 11v6" />
                    <path d="M9 6V4h6v2" />
                  </svg>
                </button>
              </div>
            </div>

            {paymentError && (
              <div className={s.paymentErrorOverlay} onClick={ClosePaymentError}>
                <div className={s.paymentErrorModal} onClick={(e) => e.stopPropagation()}>
                  <button className={s.paymentErrorClose} aria-label="Закрыть" onClick={ClosePaymentError}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </button>
                  <div className={s.paymentErrorIcon}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </div>
                  <h2 className={s.paymentErrorTitle}>Не удалось создать платеж</h2>
                  <p className={s.paymentErrorText}>
                    Произошла ошибка при создании платежа.
                    <br />
                    Попробуйте еще раз чуть позже.
                  </p>
                  <button className={s.paymentErrorButton} onClick={extendSub}>
                    Попробовать снова
                  </button>
                </div>
              </div>
            )}
            
            <p className={s.section_title}>Промокод</p>
            <div className={s.promo_row}>
              <input
                className={s.promo_input}
                type="text"
                placeholder="Введите промокод"
                value={promoCode}
                onChange={(e) => {
                  setPromoCode(e.target.value);
                  setPromoApplied(false);
                  setDiscount(0);
                  setPromoError('');
                }}
                disabled={promoApplied}
              />
              <button
                className={s.promo_btn}
                onClick={applyPromo}
                disabled={promoApplied || !promoCode.trim()}
              >
                ✓

                {/* {promoApplied ? '✓' } */}
              </button>
              <button
                className={s.promo_btn_min}
                onClick={applyPromo}
                disabled={promoApplied || !promoCode.trim()}
              >
                {promoApplied ? '✓' : '✓'}
              </button>
            </div>
            {promoError && <p className={s.promo_error}>{promoError}</p>}
            {promoApplied && <p className={s.promo_success}>Промокод применён — скидка {discount}%</p>}

            <div className={s.divider} />

            <p className={s.section_title}>Итого</p>
            <div className={s.summary_row}>
              <span className={s.dot_blue}>● Подписки</span>
              <span>{price} ₽</span>
            </div>
            <div className={s.summary_row}>
              <span className={s.dot_green}>● Скидка</span>
              <span className={s.discount}>{promoApplied ? `-${price - finalPrice} ₽` : '0 ₽'}</span>
            </div>

            <div className={s.total_box}>
              <span className={s.total_label}>Итого к оплате</span>
              <span className={s.total_price}>{finalPrice} ₽</span>
            </div>

            <button 
              className={s.pay_btn} 
              onClick={extendSub} 
              disabled={isLoading}
            >
              {isLoading ? (
                <svg className={s.spinner} viewBox="0 0 50 50">
                  <circle className={s.path} cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                </svg>
              ) : (
                "Перейти к оплате →"
              )}
            </button>
          </div>

          <button className={s.continue_btn} onClick={() => navigate('/')}>← Продолжить покупки</button>
        </div>
      ) : (
        <div className={s.page}>
          <h1 className={s.title}>Корзина</h1>
          <p className={s.subtitle}>Проверь свою подписку и перейди к оформлению</p>

          <div className={s.card}>
            <div className={s.empty}>
              <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#3a4a6b" strokeWidth="1.2">
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
              </svg>
              <p className={s.empty_title}>В корзине пусто</p>
              <p className={s.empty_sub}>Добавь товары или подписку,<br />чтобы оформить заказ.</p>
            </div>
          </div>

          <button className={s.continue_btn} onClick={() => navigate('/')}>← Продолжить покупки</button>
        </div>
      )}
    </>
  );
};

export { Buy };